'use strict';
var population = document.querySelectorAll('.population');
var populationArray = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = population[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var el = _step.value;
        populationArray.push(el.textContent.split(',').join(''));
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var totalPopulationEl = document.querySelector('.total-population');
var averagePopulationEl = document.querySelector('.average-population');
var total = populationArray.reduce(function(acc, sum) {
    var num = Number(sum);
    if (isNaN(num)) return acc;
    return acc + num;
}, 0);
var average = Math.floor(total / populationArray.length);
totalPopulationEl.textContent = total.toLocaleString('en-US');
averagePopulationEl.textContent = average.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.4e0f7273.js.map
